export default __webpack_public_path__ + "static/media/Gateways.c846a9cd.xlsx";